import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from "../../services/authentication.service";
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import {Message, SelectItem} from "primeng/api";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TemplateService} from "../../services/template.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-tax-report',
  templateUrl: './zip-file.component.html',
  styleUrls: ['./zip-file.scss'],
  providers: [TemplateService]
})
export class ZipFileComponent implements OnInit {
  itemsPerPage = 40;

  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  canDownloadZipOption: any;
  selectedCanDownloadZip: SelectItem[];
  msgs: Message[] = [];
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allBranch = true;
  allDocType = true;
  notUploaded: any;
  branch: any;
  branchSuggest: any;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allBranchSelected = [];
  selectedValues = [];
  test: any;
  tableData: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  no_data = true;
  value: number = 0;
  sum_docs_count: number = 0;
  loading_all_zip_progress: number = 0;
  errorMsg = '';
  monthList = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];

  selectedMonth: any;
  selectedYear: any;

  allZipCount: number;
  allZipCurrent = 0;

  index = 0;
  tableArray = [];
  modalData: any;

  uploaded_row_count: 0;
  total_rows_count: 0;

  branchList: any = null;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  docTypeList: any = null;

  loading_excel_report = false;

  sortBy: string;
  sortMode: string;
  is_TH = false;

  rdDocumentType: any;
  selectedRdDocumentType: any;

  tableCol = [
    // { field: 'group', header: 'ประเภทธุรกิจ' },
    { field: 'branch', header: 'ชื่อสาขา' },
    { field: 'rd_doc_type', header: 'ประเภทเอกสาร' },
    // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
    { field: 'total_doc', header: 'จำนวนเอกสาร' }
  ];

  @ViewChild('tt') table: any;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'th') {
        this.is_TH = true;
      }
      if (event.lang === 'en') {
        this.is_TH = false;
      }

      this.populateDropdown();
    });
    this.loadTexts();
    this.populateDropdown();
    this.searchData();
  }
  loadTexts() {

    this.tableCol = [];
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      const documentData = this.template.getDropdown();
      documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.rdDocumentType = documentData;
      this.loadInput();

      this.tableCol.push(
        // { field: 'group', header: 'ประเภทธุรกิจ' },
        // {field: 'company_name', header: this.translate.instant('FILTER.COMPANY')},
        {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
        {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
        // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
        {field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS')}
      )
    });
  }

  populateDropdown() {
    this.monthListDropdown = [];
     this.monthListDropdown.push(
        {label: this.translate.instant('MONTH.JANUARY'), value: 1},
        {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
        {label: this.translate.instant('MONTH.MARCH'), value: 3},
        {label: this.translate.instant('MONTH.APRIL'), value: 4},
        {label: this.translate.instant('MONTH.MAY'), value: 5},
        {label: this.translate.instant('MONTH.JUNE'), value: 6},
        {label: this.translate.instant('MONTH.JULY'), value: 7},
        {label: this.translate.instant('MONTH.AUGUST'), value: 8},
        {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
        {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
        {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
        {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
      );
    var currentDate = new Date();
    // populate year list back within 10 years
    var thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  canUserDownloadDoc() {
    return this.authService.isAccountantAdmin() || this.authService.isUIH();
  }

  loadInput() {
    this.company = [{
     label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          })
        });
      }
    );

    this.homeproGroup = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompanyGroup().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          })
        });
      }
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.canDownloadZipOption = [{
      label: 'ทั้งหมด',
      value: null
    },{
      label: 'เฉพาะที่ตรวจสอบจากบัญชีแล้ว',
      value: true
    },{
      label: 'เฉพาะที่ยังไม่ได้ตรวจสอบ',
      value: false
    }];

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if(this.selectedCompany == null || obj.corporate == this.selectedCompany)
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        })
    });
  }

  getProgress() {
    let progress = this.total_rows_count > 0 ? ((this.uploaded_row_count/this.total_rows_count)*100.0) : 0
    return Math.floor(progress)
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  searchBranch(event) {
    if (this.branchList == null) {
      this.apiService.getBranch().subscribe(
        (data) => {
          this.branchList = data;
          this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
      )
    } else {
      this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.apiService.getDocumentType().subscribe(
        (result) => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList)
        }
      )
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList)
    }
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim()

    let filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      let data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  selectAllBranch() {
      this.branch = null;
  }

  selectDocType() {
      this.documentType = null;
  }

  canUserApproveDoc() {
    return this.authService.isAccountant();
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if(this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    this.allBranchSelected = [];
    this.allDocumentType = [];
    _.forEach(this.branch, (data) => {
      // this.allBranchSelected = [];
      this.allBranchSelected.push(_.toNumber(data.id))
    });
    _.forEach(this.documentType, (data) => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(data.id))
    });

    const data = {
      not_uploaded_only: this.notUploaded,
      month: this.selectedMonth,
      year: this.selectedYear,
      group_id: this.selectedHomeproGroup,
      company_id: this.selectedCompany,
      can_download_zip: this.selectedCanDownloadZip,
      document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
      //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      branch_id: this.selectedBranch ? [this.selectedBranch] : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.apiService.postSaleZipTax(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.uploaded_row_count = result.uploaded_row_count;
        this.total_rows_count = result.total_rows_count;
        this.sum_docs_count = result.sum_docs_count;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;

        this.selectedValues = [];
        for(let i=0;i<this.tableData.length;i++)
          this.selectedValues.push(false);
      },
      error => {
        this.loading = false;
        this.no_data = true;
         this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    )
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  confirmDocument(event, content, index, data) {
    event.currentTarget.blur();
    event.preventDefault();
    this.modalData = data;
    this.modal = this.modalService.open(content)
  }

  confirm() {
    if (this.modalData.uploaded === false) {
      const params = {
        approved: true,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    } else {
      const params = {
        approved: false,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      )
    }
  }

  revertBack() {
    this.searchData();
    this.modal.close();
  }

  clearData() {
    this.startDate = new Date();
    this.endDate = new Date();
    this.selectedCompany = null;
    this.selectedCanDownloadZip = null;
    this.selectedHomeproGroup = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.notUploaded = false;
    this.selectedBranch = null;

    this.searchButtonClicked();
  }

  getExportDocs(data) {
    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      document_type_id: data.document_type,
      rd_document_type: data.rd_document_type,
      branch_id: data.corporate_branch,
      group_id: data.group
    };

    data.loading_zip = true;
    this.apiService.getAllZipFile(params).subscribe(
      (obj) => {
        let filename = this.getZipFileName(data);
        this.apiService.createDownloadFile(obj, filename);

        if (!data.uploaded)
          this.uploaded_row_count++;

        data.uploaded = true;
        data.loading_zip = false;
      },
      error => {
        data.loading_zip = false;
      }
    )
  }

  clearBranch() {
    this.allBranchSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  checkCondition() {
    this.errorMsg = '';

    let errorMsgList = [];
    if(_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
    }
  }

  selectAll() {
    for(let i=0;i < this.tableData.length;i++) {
      this.selectedValues[i] = (this.tableData[i].can_download_zip === true)
    }
  }

  deselectAll() {
    for(let i=0;i < this.tableData.length;i++) {
      this.selectedValues[i] = false;
    }
  }

  canSelectAll() {
    return this.tableData.filter(data => data.can_download_zip === true).length > 0
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  DownloadSelected(content) {
    this.tableArray = [];

    for(let i=0;i < this.selectedValues.length;i++) {
      if(!this.selectedValues[i])
        continue;

      this.tableArray.push(this.tableData[i]);
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;
      this.download(this.index, this.tableArray);
    }
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select == true).length > 0
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.apiService.getExcelReport(params).subscribe(
      (obj) => {
        let filename = 'tax_report_' + this.selectedMonth + '_' + this.selectedYear  + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        this.loading_excel_report = false
      },
      error => {
        this.loading_excel_report = false
      }
    )
  }

  download(index, tableArray){
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message = 'Download ' + this.translate.instant('COMMON.COMPLETE') + ' (' + this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' + this.translate.instant('SEARCH.ITEMS') + ')';

      for(let i=0;i<tableArray.length;i++) {
        if (!tableArray[i].uploaded)
          this.uploaded_row_count++;

        tableArray[i].uploaded = true
      }

      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      document_type_id: tableArray[index].document_type,
      rd_document_type: tableArray[index].rd_document_type,
      branch_id: tableArray[index].corporate_branch,
      group_id: tableArray[index].group,
    };

    this.apiService.getAllZipFile(params).subscribe(
      (obj) => {
        if (this.cancel_loading_all_zip) {
          return;
        }

        // this.loading_all_zip = false;
        let filename = this.getZipFileName(tableArray[index]);
        this.apiService.createDownloadFile(obj, filename);
        this.allZipCurrent++;
        this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
        // data.xmlLoading = false;
        setTimeout(() => {
          this.download(index + 1, tableArray);
        }, 1000);
      },
      error => {
        this.loading_all_zip = false;
        this.loading_all_zip_message = this.translate.instant('ERROR.TRY-AGAIN');
        // data.xmlLoading = false;
      }
    )
  }

  getZipFileName(data) {
    let file_name = '' + this.selectedMonth + '_' + this.selectedYear + '_' + data.branch__code + '_' + data.branch__rd_id + '_' + data.document_type__type;
    file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
    return file_name + '.zip'
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }

    // this.searchData();
  }

  testt(tt) {
    console.log(tt);
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.component.ts